const reg_domain = /^((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/;
const reg_prevent_domain = /[^-=\d\w.-]/;
const reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const reg_url_path = /^http:\/\/|https:\/\/|\//;
const reg_ip4 = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
const reg_ip4_range = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([1-9]|([12][0-9])|3[012]))?$/
const reg_number = /[0-9]/
const reg_alphabat_upper = /[A-Z]/
const reg_alphabat_lower = /[a-z]/
const reg_spacial = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/

const reg = {
  reg_number : reg_number,
  reg_alphabat_upper : reg_alphabat_upper,
  reg_alphabat_lower : reg_alphabat_lower,
  reg_spacial : reg_spacial,
	email : reg_email,
	domain : reg_domain,
	prevent_domain : reg_prevent_domain,
	url_path : reg_url_path,
	ip4 : reg_ip4,
	ip4_range : reg_ip4_range
};
export default reg;
export { reg_email, reg_domain, reg_prevent_domain, reg_url_path, reg_ip4, reg_ip4_range };
